'use client';

import { c as _c } from "react/compiler-runtime";
import { useToast } from '@common/hooks';
import { useSearchParams } from 'next/navigation';
import { Suspense, useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useCustomRouter } from '@/hooks/useCustomRouter';
const ToastSearchParamsControllerComponent = () => {
  const $ = _c(7);
  const searchParams = useSearchParams();
  const {
    replace
  } = useCustomRouter();
  const {
    toast
  } = useToast();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("toast");
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const toastMessage = t0;
  let t1;
  let t2;
  if ($[2] !== replace || $[3] !== toast || $[4] !== toastMessage) {
    t1 = () => {
      if (!toastMessage) {
        return;
      }
      toast({
        message: toastMessage
      });
      const url = new URL(window.location.href);
      url.searchParams.delete("toast");
      replace(url.toString());
    };
    t2 = [toastMessage, toast, replace];
    $[2] = replace;
    $[3] = toast;
    $[4] = toastMessage;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  useEffect(t1, t2);
  return null;
};
export const ToastSearchParamsController = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ErrorBoundary fallback={null}><Suspense fallback={null}><ToastSearchParamsControllerComponent /></Suspense></ErrorBoundary>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};